import PropTypes from 'prop-types';

import { aisleContentStyles } from 'features/shop/AisleContent';
import ProductCardV2 from 'features/shop/ProductCardV2';
import MaxLoyaltyPointsSpendAlert from 'pages/shop/ShopWithPoints/MaxLoyaltyPointsSpendAlert';
import { sortSoldOutProductsLast } from 'utils/aislesUtils';

function AvailableGiftsTab({ products, showMaxLoyaltyPointsSpendAlert }) {
    return (
        <>
            {showMaxLoyaltyPointsSpendAlert && <MaxLoyaltyPointsSpendAlert />}
            <p className="text-body-md my-20">
                Shop with Points allows you to purchase items with your loyalty points. Redeemed items will be visible
                in your cart, and shipped with your next order. Points are not officially redeemed until your shopping
                window closes.
            </p>
            {products.length > 0 ? (
                <div className={aisleContentStyles.aisleSectionV2}>
                    {sortSoldOutProductsLast(products)?.map((product) => (
                        <ProductCardV2
                            data={product}
                            key={product.name}
                            metaData={{
                                aisleID: null,
                                carouselID: null,
                                carouselName: null,
                                customAisle: true,
                                isCarouselModalCard: false,
                                searchRecommendation: false,
                            }}
                            variant="PERK"
                        />
                    ))}
                </div>
            ) : (
                <p className="text-body-md">Sorry, there are no Shop with Points items available at this time.</p>
            )}
        </>
    );
}

AvailableGiftsTab.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    showMaxLoyaltyPointsSpendAlert: PropTypes.bool,
};

AvailableGiftsTab.defaultProps = {
    showMaxLoyaltyPointsSpendAlert: false,
};

export default AvailableGiftsTab;
